// extracted by mini-css-extract-plugin
export default {"resizeHandle":"resizable-handle_resizeHandle__fwa8+","resizeHandleInner":"resizable-handle_resizeHandleInner__Ean2v"};